import { useLang } from "../i18n";

export default function About() {
  const { t } = useLang();
  return (
    <section id="about" className="relative py-24 lg:py-32 bg-[#FAF4EA] overflow-hidden">
      {/* soft decorative circle */}
      <div className="absolute -right-40 top-1/4 w-96 h-96 rounded-full bg-[#9C3B2E]/5 blur-3xl" />

      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16 items-center">
        {/* Team photo */}
        <div className="reveal relative">
          <div className="relative rounded-[2rem] overflow-hidden shadow-[0_30px_60px_-20px_rgba(42,36,32,0.4)]">
            <img
              src="/about-team.jpg"
              alt="Das Team von Quattro Tavoli"
              className="w-full h-[520px] object-cover object-center"
            />
          </div>
        </div>

        {/* Text */}
        <div className="reveal">
          <span className="inline-flex items-center gap-2 text-[#9C3B2E] text-xs uppercase tracking-[0.35em] mb-5">
            <span className="w-8 h-px bg-[#9C3B2E]" /> {t("about.eyebrow")}
          </span>
          <h2 className="font-display text-4xl sm:text-5xl font-700 text-[#2A2420] leading-tight">
            <span className="italic text-[#9C3B2E]">Benvenuti</span>
          </h2>
          <p className="mt-7 text-lg text-[#4A423B] leading-relaxed font-body">
            {t("about.p1")}
          </p>
        </div>
      </div>
    </section>
  );
}
